import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const HeaderLeftContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
`;

export const HeaderRightContent = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
  max-width: 300px;
`;